import { firestore } from "services/firebase";
import { isUserPremium } from "./firebase";
import { collection, addDoc }from "firebase/firestore";
import { app } from "./firebase";
import { getFunctions, httpsCallable } from "firebase/functions";
import { onSnapshot } from "firebase/firestore";

const sendToCheckoutSession = async ({ user }) => {
  console.log("sendToCheckoutSession ...");

  const premium = await isUserPremium();
  if (premium) {
    sendToStripeCustomerPortal({ returnPath: "/" });
    return;
  }

  try {
    const collectionRef = await collection(firestore, "customers", user.uid, "checkout_sessions");
    const docRef = await addDoc(collectionRef, {
      price: "price_1Jaqf2CB2n4uDWOps8NZdBjo",
      success_url: window.location.origin + "/?checkout=success",
      cancel_url: window.location.origin + "/customer/sign-up",
    });

    // Wait for the CheckoutSession to get attached by the extension
    await onSnapshot(docRef, (snap) => {
      const { error, url } = snap.data();
      if (error) {
        // Show an error to your customer and
        // inspect your Cloud Function logs in the Firebase console.
        alert(`An error occured: ${error.message}`);
      }
      if (url) {
        // We have a Stripe Checkout URL, let's redirect.
        window.location.assign(url);
      }
    });
  } catch (e) {
    console.log(e);
  }
};

const sendToStripeCustomerPortal = async ({ returnPath }) => {
  console.log("sendToStripeCustomerPortal ...");

  const functions = getFunctions(app, "australia-southeast1");

  const functionRef = httpsCallable(
    functions,
    "ext-firestore-stripe-subscriptions-createPortalLink"
  );

  const { data } = await functionRef({
    returnUrl: window.location.origin + returnPath,
  });
  window.location.assign(data.url);
};

export { sendToCheckoutSession, sendToStripeCustomerPortal };
